import React, { useState, useEffect } from 'react';

/**
 * SunriseAnimation - Welcome Delight
 * 
 * A large, bright sun with a smiling face appears in the top-left corner
 * every time the user opens/refreshes the map page.
 * 
 * Timing:
 * - Loads immediately with page (minimal delay)
 * - Grows and brightens over 3.6 seconds
 * - Quick fade and disappear
 * - Total: ~4 seconds
 * 
 * Architecture:
 * - Uses Invisible Net principles (non-intrusive)
 * - Independent overlay (doesn't interfere with insect bursts)
 * - Triggers on every page load/refresh
 * - Respects accessibility (prefers-reduced-motion)
 */

const SunriseAnimation = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Check accessibility preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      console.log('☀️ Sunrise: Reduced motion preferred, skipping');
      return;
    }

    // Show the sun on every page load!
    console.log('☀️ Sunrise: Initiating sunrise animation');
    
    // Small delay to ensure page is stable (100ms)
    setTimeout(() => {
      setShouldShow(true);
      setIsAnimating(true);
      
      // Total animation: 3.6s grow/brighten + 0.4s fade = 4s
      // Remove from DOM after completion
      setTimeout(() => {
        setIsAnimating(false);
        setTimeout(() => {
          setShouldShow(false);
          console.log('☀️ Sunrise: Animation complete');
        }, 400); // Wait for fade out
      }, 3600); // After grow/brighten phase
      
    }, 100);
    
  }, []); // Run once on mount

  // Don't render if shouldn't show
  if (!shouldShow) {
    return null;
  }

  return (
    <div
      className={`sunrise-container ${isAnimating ? 'sunrise-animating' : 'sunrise-fade-out'}`}
      aria-hidden="true"
      role="presentation"
    >
      {/* Sun with smiling face */}
      <div className="sunrise-sun">
        {/* Sun rays (optional enhancement) */}
        <div className="sunrise-rays"></div>
        
        {/* Sun circle with face */}
        <div className="sunrise-face">
          {/* Eyes */}
          <div className="sunrise-eyes">
            <div className="sunrise-eye sunrise-eye-left"></div>
            <div className="sunrise-eye sunrise-eye-right"></div>
          </div>
          {/* Smile */}
          <div className="sunrise-smile"></div>
        </div>
      </div>
    </div>
  );
};

export default SunriseAnimation;
